
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "DashboardText1222929375",
      {"classes":{"root":"DashboardText1222929375__root"},"vars":{"width":"--width"},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  